import React from 'react';
import SimpleForm from '../teal-react/components/organisms/SimpleForm';
import { useUnitLookup } from '../graphql/queries';
import Loading from '../teal-react/components/molecules/Loading';
import SimpleCard from '../teal-react/components/organisms/SimpleCard';
import { useSaveDelete } from '../graphql/hooks';
import MaterialsEditor from './MaterialsEditor';
import { useAuth } from '../teal-react/utils/token';
import SimpleDeleteConfirm from '../teal-react/components/organisms/SimpleDeleteConfirm';

interface FormulaFormOptions {
  formula: any;
  onClose?: () => void;
}

const FormulaForm = ({ formula, onClose }: FormulaFormOptions) => {
  const [deleteId, setDeleteId] = React.useState(0);
  const [model, setModel] = React.useState(formula);
  const { data: units } = useUnitLookup();
  const [save, deleteFomula] = useSaveDelete('formula', 'formula');
  const { user } = useAuth();

  if (!units) {
    return <Loading />;
  }
  return (
    <>
      <SimpleCard raised noGutter>
        <SimpleForm
          header={'Formula Editor'}
          cancel={onClose}
          model={model}
          onDelete={() => {
            setDeleteId(model.id);
          }}
          resetOnSave={!model.id}
          saveLabel={
            !model.id ? 'Create Formula, Add Materials' : 'Save Changes'
          }
          save={({ modified, merged }: { modified: any; merged: any }) => {
            if (model.id) {
              save({ id: model.id, ...modified });
              onClose?.();
            } else {
              save(merged, true).then((ret: any) => {
                setModel({
                  id: ret.createformula,
                  ...model,
                  ...merged,
                });
              });
            }
          }}
          fields={[
            {
              name: 'name',
              label: 'Formula',
              size: 3,
              validate: { required: true },
            },
            {
              name: 'amount',
              label: 'Amount',
              size: 3,
              number: true,
              validate: { required: true },
            },
            {
              name: 'unit_id',
              label: 'Unit',
              size: 2,
              options: units.unit.map((u: any) => ({
                label: u.name,
                value: u.id,
              })),
              validate: { required: true },
            },
          ]}
        />
        {model.id ? <MaterialsEditor id={model.id} /> : null}
      </SimpleCard>
      {deleteId ? (
        <SimpleDeleteConfirm
          onCancel={() => setDeleteId(0)}
          onDelete={() => {
            deleteFomula({ id: model.id });
            onClose?.();
            setDeleteId(0);
          }}
        />
      ) : null}
    </>
  );
};

export default FormulaForm;
